import { CircularProgress, MenuItem, TextField } from "@mui/material";

import { type EvidenceDefinition } from "../types";

interface EvidenceDefinitionSelectProps {
  definitions: EvidenceDefinition[];
  selectedDefinitionId: string;
  onSelect: (definitionId: string) => void;
  isLoading: boolean;
  disabled?: boolean;
}

export function EvidenceDefinitionSelect({
  definitions,
  selectedDefinitionId,
  onSelect,
  isLoading,
  disabled,
}: EvidenceDefinitionSelectProps) {
  return (
    <TextField
      select
      label="Evidence Definition"
      value={selectedDefinitionId}
      disabled={isLoading || disabled}
      size="small"
      sx={{ width: 400 }}
      InputProps={{
        endAdornment: isLoading ? <CircularProgress size={20} /> : undefined,
      }}
      onChange={(event) => {
        onSelect(event.target.value);
      }}
    >
      <MenuItem disabled value="">
        Select a definition
      </MenuItem>
      {definitions.map((definition) => (
        <MenuItem key={definition.id} value={definition.id}>
          {definition.attributes.displayName}
        </MenuItem>
      ))}
    </TextField>
  );
}
